export default __webpack_public_path__ + "static/media/bottom_web_banner_SimplyCLICK.d6ee4077.png";